import OrderService from "./../../services/orders/OrderService";
import CheckInOrderService from './../../services/orders/CheckInOrderService'
import dispensation from "../../services/dispenzation/AllDispenzation.js"
import i18n from "./../../i18n/index";

import * as moment from 'moment';
export default {
    props: ["status", "providerId", "enabledColumns"],
    data() {
        return {
            showText: true,
            dataPicker: false,
            date: '',
            date2: '',
            search: "",
            showInput: false,
            headers: [{
                id: 0,
                text: "N° ESTUDIO",
                sortable: false,
                value: "studyNumber"
            },
            {
                id: 1,
                text: "CITA",
                sortable: false,
                value: "appointment"
            },
            {
                id: 9,
                text: 'DIAGNÓSTICO CLAVE',
                value: "diagnostic_key",
                sortable: false
            },
            {
                id: 3,
                text: "DESCRIPCIÓN DIAGNÓSTICO",
                sortable: false,
                value: "diagnostic_description"
            },
            {
                id: 4,
                text: "FECHA",
                sortable: false,
                value: "date_request"
            },
            ],
            orders: [],
            totalOrders: 0,
            loading: false,
            pagination: {},
            selectedItem: {},
            rowsPerPageItems: [5, 10, 15, 20],
            code: '',
            searchTypes: [ 'Número de estudio','Código cita'],
            searchUserTypes: ['Surtida', 'Cancelada', 'Pendiente','Parcialmente surtida'],
            searchType: 'Número de estudio',
            searchUserType: 'POS',
            minDate: moment().format('YYYY-MM-DD')
        };
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    mounted() {
        // this.focusInput();
        this.showInputSearchInvoice();
    },
    watch: {
        pagination: {
            handler() {
                this.getOrders();
            },
            deep: true
        }
    },
    methods: {
        // focusInput() {
        //     this.$refs.code.focus();
        //     console.log(this.$refs.code.focus())
        // },
        showColumn(i) {
            return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
        },
        getOrders() {
         
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            if (this.date !== null & this.date !== undefined && this.date !== '') { 
                if (this.date2 === null || this.date2 === undefined || this.date2 === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha final'
                    })
                    this.loading = false;
                    return
                }
            }
            console.log("paso get");
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') { 
                if (this.date === null || this.date === undefined || this.date === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha inicial'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date === null || this.date === undefined) {
                this.date = ''
            }
            if (this.date2 === null || this.date2 === undefined) {
                this.date2 = ''
            }
            let searchTypeAux = ''
            if (this.searchType === 'Documento') {
                searchTypeAux = 'document_id'
            } else if (this.searchType === 'Número de estudio') {
                searchTypeAux = 'study_number'
            } else if (this.searchType === 'Código cita') {
                searchTypeAux = 'appointment'
            } else if (this.searchType === 'Estado') {
                searchTypeAux = 'status'
                this.search =  this.search == 'Surtida' ? '1' : this.search == 'Cancelada' ? '2' : this.search == 'Pendiente' ? '3' : this.search == 'Parcialmente surtida' ? '4':null; 
            } else if (this.searchType === 'Tipo de examen'){
                searchTypeAux = 'code';  
                console.log("this.search",this.search)   
                
            }
            dispensation.getConsultLab(
                page ,
                rowsPerPage,
                this.search,
                this.status ? this.status : "",
                this.providerId ? this.providerId : "",
                this.date,
                this.date2,
                searchTypeAux
            ).then(data => {
                this.loading = false;
                console.log("data",data)
                this.orders = data.data[0].map(order => {
                    order.status = this.mapStatus(order.status);
                    return order;
                  });
                this.totalOrders = data.data[1];
            });
        },
        mapStatus(status) {
            const statusMap = {
              '1': 'SURTIDA',
              '2': 'CANCELADA',
              '3': 'PENDIENTE',
              '4': 'PARCIALMENTE SURTIDA'
            };
            return statusMap[status] || null;
          },
        onRowClick(item) {
            console.log("item",item)
           
            this.$router.push({
                path: "/lab-update",
                query: { item },
              });
       
        },
        async onChange(invoice) {
            this.showText = false
            let response = await CheckInOrderService.getIdOrder({ facturaNumber: invoice })
            let idOrder = response.data
            // let order2 = this.orders.find(order => {
            //     return order.id == idOrder
            // })
            let response2 = await OrderService.getOrder(idOrder)
            let order = response2.data
            this.$emit("row-click", order, invoice)
        },
        showInputSearchInvoice() {
            let pathRoute = this.$router.currentRoute.path
            if (pathRoute === '/check-in-order') {
                this.showInput = true
            }
        },
        changeInitialDate() {
            let initialDate = moment(this.date).format('YYYY-MM-DD')
            this.minDate = initialDate
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') {
                if (!moment(this.date2).isSameOrAfter(initialDate)) {
                    this.date2 = this.minDate
                }
            } else {
                this.date2 = this.minDate
            }
        }
    }
};